import { render, staticRenderFns } from "./ConfigureSplashScreen.vue?vue&type=template&id=536d04b6&scoped=true"
import script from "./ConfigureSplashScreen.vue?vue&type=script&lang=js"
export * from "./ConfigureSplashScreen.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSplashScreen.vue?vue&type=style&index=0&id=536d04b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d04b6",
  null
  
)

export default component.exports